export default __webpack_public_path__ + "static/media/platform_advantages_icon4.bc80831b.png";